module.exports = __webpack_public_path__ + "static/img/butterflyTechnical.7c876d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/butterflyTechnical.png
// module id = TMwn
// module chunks = 1